import { ArrowBack, ArrowForward, CalendarToday } from '@mui/icons-material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import styled from 'styled-components';

interface IProps {
  value: string;
  onChange: (value: string) => void;
}

const ListDatePicker = ({ value, onChange }: IProps) => {
  const onChangeInput = (value: any | unknown) => {
    if (!value) {
      return;
    }
    const year = value.$y;
    const month = value.$M + 1;
    const day = value.$D;
    const changedMonth = month < 10 ? `0${month}` : month;
    const changedDay = day < 10 ? `0${day}` : day;
    onChange(`${year}-${changedMonth}-${changedDay}`);
  };

  const onPrev = () => {
    onChange(dayjs(value).subtract(1, 'day').format('YYYY-MM-DD'));
  };

  const onNext = () => {
    // Move Next day if before Today
    if (dayjs().diff(dayjs(value), 'day') > 0) {
      onChange(dayjs(value).add(1, 'day').format('YYYY-MM-DD'));
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <PickerTemplate>
        <DayButton onClick={onPrev}>
          <ArrowBack fontSize="small" />
        </DayButton>
        <CustomDateField
          value={dayjs(value)}
          format={'YYYY-MM-DD'}
          maxDate={dayjs()}
          slots={{ openPickerIcon: CalendarToday }}
          onChange={(newValue) => {
            onChangeInput(newValue);
          }}
        />
        <DayButton onClick={onNext}>
          <ArrowForward fontSize="small" />
        </DayButton>
      </PickerTemplate>
    </LocalizationProvider>
  );
};

const PickerTemplate = styled.div`
  display: flex;
  width: 288px;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;
const CustomDateField = styled(DatePicker)`
  display: flex;
  justify-content: center;

  .MuiInputBase-root {
    width: 9.125rem;
    height: 40px;
    bottom: 0;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(138.99deg, rgba(0, 184, 219, 0.2) 3.03%, rgba(43, 127, 255, 0.2) 96.97%);
    font-family: '' Inter '';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
    :focus {
      outline: 0;
    }
  }
  .MuiOutlinedInput-root button {
    padding: 0px 2px 0px 0px;
  }
  .MuiSvgIcon-root {
    color: #53eafd;
  }
  .MuiOutlinedInput-root fieldset {
    border: 0;
  }
  .MuiOutlinedInput-input {
    text-align: center;
    padding: 0px 0px 0px 5px;
  }
`;
const DayButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(138.99deg, rgba(0, 184, 219, 0.2) 3.03%, rgba(43, 127, 255, 0.2) 96.97%);
  color: #53eafd;
  cursor: pointer;
  transition: all 0.2s;
`;

export default ListDatePicker;
